import React from 'react';
import { Button } from '@mui/material';
import { useLanguage } from '../contexts/LanguageContext';

const LanguageSwitcher: React.FC = () => {
  const { language, setLanguage } = useLanguage();

  const toggleLanguage = () => {
    setLanguage(language === 'en' ? 'ar' : 'en');
  };

  return (
    <Button
      onClick={toggleLanguage}
      size="small"
    sx={{
  color: '#010101',
  fontWeight: 'bold',
  minWidth: '48px',
  px: 1.5,
  py: 0.5,
  borderRadius: '5px',
  fontSize: '16px',
  lineHeight: 2.5,
  letterSpacing: language === 'ar' ? '0.5px' : '1px',
  cursor: 'pointer',
  textTransform: 'none',
  '&:hover': {
    background: 'none',
    boxShadow: 'none',
  },
}}
    >
      {language === 'en' ? 'العربية' : 'English'}
    </Button>
  );
};

export default LanguageSwitcher;
